module.exports = __webpack_public_path__ + "static/media/Step3Tutorial-1.0cd028a6.png";